import * as React from "react"
import * as _ from "lodash"
import TypeAhead, { TypeAheadElement } from "./TypeAhead";
import {AppConstants} from "../utils/AppConstants";

/*
 * created by aditya on 14/07/18
 */

const timePickerTypeAheadSuggestions = [
    {displayValue: "12:00 AM", internalValue: "00:00"},
    {displayValue: "12:15 AM", internalValue: "00:15"},
    {displayValue: "12:30 AM", internalValue: "00:30"},
    {displayValue: "12:45 AM", internalValue: "00:45"},
    {displayValue: "1:00 AM", internalValue: "1:00"},
    {displayValue: "1:15 AM", internalValue: "1:15"},
    {displayValue: "1:30 AM", internalValue: "1:30"},
    {displayValue: "1:45 AM", internalValue: "1:45"},
    {displayValue: "2:00 AM", internalValue: "2:00"},
    {displayValue: "2:15 AM", internalValue: "2:15"},
    {displayValue: "2:30 AM", internalValue: "2:30"},
    {displayValue: "2:45 AM", internalValue: "2:45"},
    {displayValue: "3:00 AM", internalValue: "3:00"},
    {displayValue: "3:15 AM", internalValue: "3:15"},
    {displayValue: "3:30 AM", internalValue: "3:30"},
    {displayValue: "3:45 AM", internalValue: "3:45"},
    {displayValue: "4:00 AM", internalValue: "4:00"},
    {displayValue: "4:15 AM", internalValue: "4:15"},
    {displayValue: "4:30 AM", internalValue: "4:30"},
    {displayValue: "4:45 AM", internalValue: "4:45"},
    {displayValue: "5:00 AM", internalValue: "5:00"},
    {displayValue: "5:15 AM", internalValue: "5:15"},
    {displayValue: "5:30 AM", internalValue: "5:30"},
    {displayValue: "5:45 AM", internalValue: "5:45"},
    {displayValue: "6:00 AM", internalValue: "6:00"},
    {displayValue: "6:15 AM", internalValue: "6:15"},
    {displayValue: "6:30 AM", internalValue: "6:30"},
    {displayValue: "6:45 AM", internalValue: "6:45"},
    {displayValue: "7:00 AM", internalValue: "7:00"},
    {displayValue: "7:15 AM", internalValue: "7:15"},
    {displayValue: "7:30 AM", internalValue: "7:30"},
    {displayValue: "7:45 AM", internalValue: "7:45"},
    {displayValue: "8:00 AM", internalValue: "8:00"},
    {displayValue: "8:15 AM", internalValue: "8:15"},
    {displayValue: "8:30 AM", internalValue: "8:30"},
    {displayValue: "8:45 AM", internalValue: "8:45"},
    {displayValue: "9:00 AM", internalValue: "9:00"},
    {displayValue: "9:15 AM", internalValue: "9:15"},
    {displayValue: "9:30 AM", internalValue: "9:30"},
    {displayValue: "9:45 AM", internalValue: "9:45"},
    {displayValue: "10:00 AM", internalValue: "10:00"},
    {displayValue: "10:15 AM", internalValue: "10:15"},
    {displayValue: "10:30 AM", internalValue: "10:30"},
    {displayValue: "10:45 AM", internalValue: "10:45"},
    {displayValue: "11:00 AM", internalValue: "11:00"},
    {displayValue: "11:15 AM", internalValue: "11:15"},
    {displayValue: "11:30 AM", internalValue: "11:30"},
    {displayValue: "11:45 AM", internalValue: "11:45"},
    {displayValue: "12:00 PM", internalValue: "12:00"},
    {displayValue: "12:15 PM", internalValue: "12:15"},
    {displayValue: "12:30 PM", internalValue: "12:30"},
    {displayValue: "12:45 PM", internalValue: "12:45"},
    {displayValue: "1:00 PM", internalValue: "13:00"},
    {displayValue: "1:15 PM", internalValue: "13:15"},
    {displayValue: "1:30 PM", internalValue: "13:30"},
    {displayValue: "1:45 PM", internalValue: "13:45"},
    {displayValue: "2:00 PM", internalValue: "14:00"},
    {displayValue: "2:15 PM", internalValue: "14:15"},
    {displayValue: "2:30 PM", internalValue: "14:30"},
    {displayValue: "2:45 PM", internalValue: "14:45"},
    {displayValue: "3:00 PM", internalValue: "15:00"},
    {displayValue: "3:15 PM", internalValue: "15:15"},
    {displayValue: "3:30 PM", internalValue: "15:30"},
    {displayValue: "3:45 PM", internalValue: "15:45"},
    {displayValue: "4:00 PM", internalValue: "16:00"},
    {displayValue: "4:15 PM", internalValue: "16:15"},
    {displayValue: "4:30 PM", internalValue: "16:30"},
    {displayValue: "4:45 PM", internalValue: "16:45"},
    {displayValue: "5:00 PM", internalValue: "17:00"},
    {displayValue: "5:15 PM", internalValue: "17:15"},
    {displayValue: "5:30 PM", internalValue: "17:30"},
    {displayValue: "5:45 PM", internalValue: "17:45"},
    {displayValue: "6:00 PM", internalValue: "18:00"},
    {displayValue: "6:15 PM", internalValue: "18:15"},
    {displayValue: "6:30 PM", internalValue: "18:30"},
    {displayValue: "6:45 PM", internalValue: "18:45"},
    {displayValue: "7:00 PM", internalValue: "19:00"},
    {displayValue: "7:15 PM", internalValue: "19:15"},
    {displayValue: "7:30 PM", internalValue: "19:30"},
    {displayValue: "7:45 PM", internalValue: "19:45"},
    {displayValue: "8:00 PM", internalValue: "20:00"},
    {displayValue: "8:15 PM", internalValue: "20:15"},
    {displayValue: "8:30 PM", internalValue: "20:30"},
    {displayValue: "8:45 PM", internalValue: "20:45"},
    {displayValue: "9:00 PM", internalValue: "21:00"},
    {displayValue: "9:15 PM", internalValue: "21:15"},
    {displayValue: "9:30 PM", internalValue: "21:30"},
    {displayValue: "9:45 PM", internalValue: "21:45"},
    {displayValue: "10:00 PM", internalValue: "22:00"},
    {displayValue: "10:15 PM", internalValue: "22:15"},
    {displayValue: "10:30 PM", internalValue: "22:30"},
    {displayValue: "10:45 PM", internalValue: "22:45"},
    {displayValue: "11:00 PM", internalValue: "23:00"},
    {displayValue: "11:15 PM", internalValue: "23:15"},
    {displayValue: "11:30 PM", internalValue: "23:30"},
    {displayValue: "11:45 PM", internalValue: "23:45"}
]

export interface TimePickerProps {
    value: string;
    onChangeCallbackMeta?: string;
    onTimeChange: (time: string, meta: any) => void;
    supportMeridiem?: boolean;
}

class TimePicker extends React.Component<TimePickerProps> {
    constructor(props: TimePickerProps) {
        super(props);
        this.state = {
            value: !_.isEmpty(props.value) ? this.getDisplayValueFromInternalValue(props.value) : ""
        }
    }
    getDisplayValueFromInternalValue(value: string) {
        let displayValue = value;
        if (displayValue.length && displayValue.startsWith("0") && !displayValue.startsWith("00")) displayValue = displayValue.substr(1, displayValue.length);
        if (timePickerTypeAheadSuggestions.map(item => item.internalValue).indexOf(displayValue) !== -1) {
            let index = timePickerTypeAheadSuggestions.map(item => item.internalValue).indexOf(displayValue);
            displayValue = timePickerTypeAheadSuggestions[index].displayValue;
        }
        return displayValue;
    }
    componentWillReceiveProps(nextProps: TimePickerProps) {
        this.setState({
            value: this.getDisplayValueFromInternalValue(nextProps.value)
        })
    }
    onChangeHandler = (value: any) => {
        if (this.props.supportMeridiem) {
            let time = value;
            let splitString = time.split(" ");
            let timeToReturn = splitString[0];
            if (splitString[1] === "PM") {
                let timeString = splitString[0].split(":");
                let hour = 12 + parseInt(timeString[0]);
                let minutes = timeString[1];
                timeToReturn = `${hour}:${minutes}`;
            }
            let callbackMeta = this.props.onChangeCallbackMeta;
            this.props.onTimeChange(timeToReturn, callbackMeta);
        } else {
            let time = value.target.value;
            let callbackMeta = this.props.onChangeCallbackMeta;
            this.props.onTimeChange(time, callbackMeta);
        }
    }
    getTimeValue = (value: string) => {
        if (this.props.supportMeridiem) {
            let splitTime = value.split(":");
            let meridiem = "AM";
            if (parseInt(splitTime[0]) >= 12) {
                splitTime[0] = (parseInt(splitTime[0]) - 12).toString();
                splitTime[0] = splitTime[0].length === 1 ? "0" + splitTime[0] : splitTime[0];
                meridiem = "PM";
            }
            return `${splitTime[0]}:${splitTime[1]} ${meridiem}`;
        } else {
            return value;
        }
    }
    onTypeAheadChange = (value: string) => {
        let timeSuggestions: TypeAheadElement[] = [];
        this.setState({
            value
        })
        _.map(timePickerTypeAheadSuggestions, (timeItem) => {
            if (timeItem.displayValue.toLowerCase().indexOf(value) !== -1) {
                let typeAheadElement: TypeAheadElement = {
                    value: timeItem.internalValue,
                    label: timeItem.displayValue,
                    others: {
                        type: "time"
                    }
                }
                timeSuggestions.push(typeAheadElement);
            }
        })
        return Promise.resolve({options: timeSuggestions, completed: true});
    }
    onTypeAheadSelect = (elem: TypeAheadElement) => {
        if (this.props.supportMeridiem) {
            let time = elem.label;
            let splitString = time.split(" ");
            let timeToReturn = splitString[0];
            if (splitString[1] === "PM") {
                let timeString = splitString[0].split(":");
                let hour = 12 + parseInt(timeString[0]);
                let minutes = timeString[1];
                timeToReturn = `${hour}:${minutes}`;
            }
            let callbackMeta = this.props.onChangeCallbackMeta;
            this.props.onTimeChange(timeToReturn, callbackMeta);
        } else {
            let time = elem.value;
            let callbackMeta = this.props.onChangeCallbackMeta;
            this.props.onTimeChange(time, callbackMeta);
        }
    }
    onTypeAheadBlur = () => {
        this.setState({
            validate: true
        }, () => {
            if (this.state.value === "") {
                this.props.onTimeChange("", this.props.onChangeCallbackMeta)
                /*this.setState({
                    value: this.getDisplayValueFromInternalValue(this.props.value)
                })*/
            } /*else if (timePickerTypeAheadSuggestions.filter(item => item.displayValue === this.state.value).length < 1) {
            this.props.onTimeChange("", this.props.onChangeCallbackMeta)
        }*/
        })
    }
    isValidTime = (value: string) => {
        if (value === "" || timePickerTypeAheadSuggestions.filter(item => item.displayValue === value).length) return true;
        return false;
    }
    render() {
        // let defaultValue = this.props.supportMeridiem ? "00:00" : ""
        // let value = !_.isEmpty(this.props.value) ? this.getTimeValue(this.props.value) : defaultValue;
        let value = this.state.value;
        let className = !_.isEmpty(this.props.value) ? "" : "default-value";
        let timeError = this.state.validate && !this.isValidTime(this.state.value) ? "error" : "";
        return (
            <div className={timeError}>
                {/*<TimeInput value={value} onChange={this.onChangeHandler} className={className} />*/}
                {/*<TextField
                    id="time"
                    label=""
                    type="time"
                    defaultValue={value}
                    onChange={this.onChangeHandler}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        step: 300, // 5 min
                    }}
                />*/}
                {/*<input type="time" id="appt-time" name="appt-time" value={value} onChange={this.onChangeHandler} />*/}
                <TypeAhead name={"time-picker"} widgetName={"TimePicker"} value={value} placeholder={"--:-- AM/PM"} onTypeAheadBlur={this.onTypeAheadBlur} onTypeAheadChange={this.onTypeAheadChange} onTypeAheadSelect={this.onTypeAheadSelect}/>
            </div>
        )
    }
}

export default TimePicker;